import React, { useState } from 'react'
import { ModalContext } from './ModalContext'
import getProp from '@f/get-prop'

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState(null)
  const onOk = getProp('props.onOk', modal)
  const onCancel = getProp('props.onCancel', modal)
  // Props injected onto whatever component was passed to useModal(). The
  // component must accept and forward these to its root <Modal> (usually
  // via a `{...rest}` spread) — omitting them means the modal never
  // becomes visible (antd's Modal defaults `visible` to false) and/or
  // Cancel/close won't do anything.
  const props = {
    onCancel: onCancel || (() => setModal(null)),
    onOk: onOk || (() => setModal(null)),
    visible: true
  }

  return (
    <ModalContext.Provider value={{ setModal }}>
      {children}
      {modal ? React.cloneElement(modal, props) : <></>}
    </ModalContext.Provider>
  )
}
